import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RoutedLabelComponent } from './routed-label.component';
import { RouterLink } from '@angular/router';
import { LinkDirective } from '../link';

@NgModule({
  imports: [CommonModule, LinkDirective, RouterLink],
  declarations: [RoutedLabelComponent],
  exports: [RoutedLabelComponent],
})
export class RoutedLabelModule {}
